import './AddLookupItemModal.scss';

import React from 'react';
import PropTypes from 'prop-types';

import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import CheckCircleIcon from '@mui/icons-material/CheckSharp';
import Button from 'src/component/UI/Button';
import { useTranslation } from 'src/i18n';

export default function AddLookupItemModal (props) {
  const [key, setKey] = React.useState('');
  const [value, setvalue] = React.useState('');
  const { t } = useTranslation();

  const handleSubmit = (e) => {
    e.preventDefault();
    const lookupItem = {
      key,
      value
    };

    props.handleSubmit(lookupItem);

    setvalue('');
    setKey('');
  };

  const {
    title
  } = props;

  return (
    <Modal
      data-testid='add-lookup-item-modal'
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby='add-lookup-item-modal-title'
    >
      <div className='modal add-lookup-item-modal'>
        <h2 id='add-lookup-item-modal-title'>{t('modal.addItem', { title })}</h2>
        <form noValidate autoComplete='off' onSubmit={handleSubmit}>
          <TextField fullWidth value={key} onChange={(e) => { setKey(e.target.value); }} label={t('form.key')} />
          <TextField fullWidth value={value} onChange={(e) => { setvalue(e.target.value); }} label={t('common.value')} />
          <div className='button-bar'>
            <Button onClick={props.handleClose} >{t('common.cancel')}</Button>
            <Button type='submit' icon={<CheckCircleIcon style={{ fontSize: 14 }} />} cta>{t('common.addData')}</Button>
          </div>
        </form>
      </div>
    </Modal>
  );
}

AddLookupItemModal.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired
};

AddLookupItemModal.defaultProps = {
};
